import { render, staticRenderFns } from "./InitiatePackingModal.vue?vue&type=template&id=bc30132c&scoped=true&"
import script from "./InitiatePackingModal.vue?vue&type=script&lang=js&"
export * from "./InitiatePackingModal.vue?vue&type=script&lang=js&"
import style0 from "./InitiatePackingModal.vue?vue&type=style&index=0&id=bc30132c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc30132c",
  null
  
)

export default component.exports